module.exports = __webpack_public_path__ + "img/graine.9cba8f71.svg";